import React from 'react';

export default function CheckmarkIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      {...props}
    >
      <defs>
        <path
          id="checkmarkIconA"
          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <mask id="checkmarkIconB" fill="#fff">
          <use xlinkHref="#checkmarkIconA" />
        </mask>
        <use fill="#000" xlinkHref="#checkmarkIconA" />
        <g fill="#faa918" mask="url(#checkmarkIconB)">
          <path d="M-64-77h180V53H-64z" />
        </g>
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/Payment/components/CheckmarkIcon.svg.jsx